import Layout, { Card } from '@/components/Layout'
import { t } from '@/lib/i18n'

interface Badge { id: string; ic: string; nm: string; ds: string; earned: boolean }

export default function Index({ badges, earned }: { badges: Badge[]; earned: number }) {
  return (
    <Layout>
      <Card title={`🏅 ${t('badges.title')} (${earned}/${badges.length})`}>
        <div className="grid gap-3 grid-cols-[repeat(auto-fill,minmax(120px,1fr))]">
          {badges.map((b) => (
            <div key={b.id} className="border border-line rounded-xl p-3.5 text-center">
              <div className={'text-[34px] ' + (b.earned ? '' : 'grayscale opacity-35')}>{b.ic}</div>
              <div className="font-bold text-[13px] mt-1.5">{b.nm}</div>
              <div className="text-muted text-[11px] mt-0.5">{b.ds}</div>
            </div>
          ))}
        </div>
      </Card>
    </Layout>
  )
}
